<template>
    <div>
        <div>
            <public-menu></public-menu>
            <product-detail></product-detail>
            <bottom-nav></bottom-nav>
            <public-footer></public-footer>
        </div>
        <div id="minbar" class="minbar ">
            <div class="r_panel">
                <ul class="m_mid" id="m_mid">
                    <right-car></right-car>
                    <right-kf></right-kf>
                    <!-- <right-history></right-history> -->
                    <right-order></right-order>
                    <right-category></right-category>
                </ul>
                <ul class="m_mid" id="m_fid">
                    <right-code></right-code>
                    <right-totop></right-totop>
                    <right-yijian></right-yijian>
                </ul>
            </div>
        </div>
    </div>
    
</template>

<script>
import Public_menu from "@/components/common/public-top"
import Product_detail from "@/components/detail/index"
import Bottom_nav from "@/components/common/bottom-nav"
import Footer from "../../components/Footer.vue"

import Right_car from "@/components/common/right-car"
import Right_kf from "@/components/common/right-kf"
import Right_history from "@/components/common/right-history"
import Right_order from "@/components/common/right-order"
import Right_category from "@/components/common/right-category"
import Right_code from "@/components/common/right-code"
import Right_totop from "@/components/common/right-totop"
import Right_yijian from "@/components/common/right-yijian"
export default {
    components:{
        'public-menu': Public_menu,
        'product-detail':Product_detail,
        'bottom-nav': Bottom_nav,
        'public-footer': Footer,
        'right-car': Right_car,
        'right-kf': Right_kf,
        'right-history': Right_history,
        'right-order': Right_order,
        'right-category': Right_category,
        'right-code': Right_code,
        'right-totop': Right_totop,
        'right-yijian': Right_yijian,
    }
}
</script>

<style scoped>
@import url('../../assets/css/style.css');
</style>


// WEBPACK FOOTER //
// src/views/detail/Index.vue